<template>
  <div>
    <router-view :key="indexComponent" @changeIndex="changeIndexComponent"></router-view>
  </div>
</template>

<script>
  export default {
    name: 'AffiliateLayout',
    data(){
      return{
        indexComponent:1,
      }
    },
    methods:{
      changeIndexComponent(){
        this.indexComponent++;
      }
    }

  }
</script>
